import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import HediyeIcon from './assets/images/hediye_icon.svg';
import MakineBaskisiYokIcon from './assets/images/makinebaskiyok_icon.svg';
import DownloadIcon from './assets/images/download_icon.svg';
import UrgentIcon from './assets/images/urgent_icon.svg';
import BekleIcon from './assets/images/bekle_icon.svg';

// SVG ikonları doğrudan import edilmiş dosyalardan kullanılacaktır

// Sipariş ikonlarını render eden yardımcı fonksiyon
const renderSiparisIcons = (siparis) => {
    // Debug için kontrolü console'a yazdıralım
    console.log("Sipariş:", siparis.numara, "Kargo Durumu:", siparis.kargo_durumu, "Durumu:", siparis.durum);
    
    // Test için numara 12345 olan siparişte Acil ikonu göster (gerçek projede kaldırın)
    const testIconForDevelopment = siparis.numara === '12345';
    
    // Her durumda import edilen SVG'leri kullan
    return (
        <>
            {siparis.hediye && siparis.hediye_sayisi && (
                <span style={{ fontSize: '11px', fontWeight: 'bold', marginRight: '1px' }}>
                    {siparis.hediye_sayisi}
                </span>
            )}
            {siparis.hediye && <img src={HediyeIcon} alt="Hediye" style={{ width: '13px', height: '13px' }} />}
            {siparis.makine_baskisi_yok && <img src={MakineBaskisiYokIcon} alt="Baskı Yok" style={{ width: '13px', height: '13px' }} />}
            {((siparis.kargo_durumu && siparis.kargo_durumu.toLowerCase().includes('acil')) || testIconForDevelopment) && 
                <img src={UrgentIcon} alt="Acil" style={{ width: '13px', height: '13px' }} className="urgent-icon" />}
            {siparis.kargo_durumu === 'Beklemede' && 
                <img src={BekleIcon} alt="Beklemede" style={{ width: '13px', height: '13px' }} className="beklemede-icon" />}
        </>
    );
};


// --- ALT BİLEŞENLER ---
const kaynakKutusuTemelStili = {
    display: 'flex',
    alignItems: 'center',        // Dikeyde ortalama
    justifyContent: 'center',   // Yatayda ortalama
    width: '16px',              // Genişlik küçültüldü (22px'den 16px'e)
    height: '16px',             // Yükseklik de küçültüldü (20px'den 16px'e)
    flexShrink: "0",             // Küçülmeyi engeller
    borderRadius: '3px',        // Kenar yuvarlaklığı biraz azaltıldı
    color: 'white',
    fontWeight: 'bold',         // Harfi kalın yapmak için
    fontSize: '10px'            // Harf boyutu küçültüldü (12px'den 10px'e)
};

// Standart (4x7) bir sipariş kartını oluşturan bileşen
const SiparisKarti = ({ siparis }) => {
    // Kargo durumunu ve beklemede durumunu kontrol et
    const isUrgent = siparis.kargo_durumu === 'Acil';
    const isBeklemede = siparis.kargo_durumu === 'Beklemede';
    
    const kartStili = {
        background: 'white', height: '100%', display: 'flex',
        flexDirection: 'column', fontSize: '11px', fontFamily: 'Poppins, sans-serif',
        border: isUrgent ? '2px solid #dc3545' : isBeklemede ? '2px solid #FFCC24' : '1px solid #333', 
        boxSizing: 'border-box'
    };
    const baslikStili = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f0f0f0', padding: '3px 5px', fontWeight: 'bold', borderBottom: '1px solid #ccc', fontSize: '12px' };
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const urunIzgaraKapsayici = { display: 'flex', flex: 1, overflow: 'hidden' };
    const urunSutunu = { flex: 1, display: 'flex', flexDirection: 'column' };
    const urunHucre = { padding: '1px 4px', fontSize: '9px', borderBottom: '1px solid #eee', borderRight: '1px solid #eee', flex: '1 1 0', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    
    // Ürünler backend'den ortak sıralamayla gelir (Özel Baskı, Metrelik, Esmaül Hüsna, Büyük Ebat, Makine, Yan Ürünler)
    const siraliUrunler = siparis.urunler || [];

    const solSutunUrunleri = siraliUrunler.slice(0, 7);
    const sagSutunUrunleri = siraliUrunler.slice(7, 14);

    return (
        <div style={kartStili}>
            <div style={baslikStili}>
                <div style={{ ...kaynakKutusuTemelStili, background: kaynakRenkleri[siparis.kaynak] || '#ccc' }}>
                {siparis.kaynak}
                </div>
                <span>{siparis.numara}{siparis.alternatif_numara ? ` (${siparis.alternatif_numara})` : ''}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                    {renderSiparisIcons(siparis)}
                </div>
            </div>
            <div style={urunIzgaraKapsayici}>
                <div style={urunSutunu}>
                    {Array.from({ length: 7 }).map((_, index) => {
                        const urun = solSutunUrunleri[index];
                        return (<div key={`sol-${index}`} style={{ display: 'flex', flex: 1 }}><span style={{ ...urunHucre, flex: 3, borderLeft: '1px solid #eee' }}>{urun ? urun.kod : '\u00A0'}</span><span style={{ ...urunHucre, flex: 1, justifyContent: 'center' }}>{urun ? urun.adet : '\u00A0'}</span></div>);
                    })}
                </div>
                <div style={{ ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                    {Array.from({ length: 7 }).map((_, index) => {
                        const urun = sagSutunUrunleri[index];
                        return (<div key={`sag-${index}`} style={{ display: 'flex', flex: 1 }}><span style={{ ...urunHucre, flex: 3 }}>{urun ? urun.kod : '\u00A0'}</span><span style={{ ...urunHucre, flex: 1, justifyContent: 'center' }}>{urun ? urun.adet : '\u00A0'}</span></div>);
                    })}
                </div>
            </div>
        </div>
    );
};

// Boş Standart Kart
const BosSiparisKarti = () => {
    const kartStili = {
        background: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '1.5px solid #ccc',
        boxSizing: 'border-box',
        opacity: 0.6
    };
    const baslikStili = {
        height: '18px',
        background: '#f0f0f0',
        borderBottom: '1px solid #ccc'
    };
    const urunIzgaraKapsayici = {
        display: 'flex',
        flex: 1,
        overflow: 'hidden'
    };
    const urunSutunu = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    };
    const urunHucre = {
        height: '15.7px',
        borderBottom: '1px solid #eee',
        borderRight: '1px solid #eee',
        flex: '1 1 0'
    };

    return (
        <div style={kartStili}>
            <div style={baslikStili}></div>
            <div style={urunIzgaraKapsayici}>
                <div style={urunSutunu}>
                    {Array.from({ length: 7 }).map((_, index) => (
                        <div key={`sol-bos-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3, borderLeft: '1px solid #eee' }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
                <div style={{ ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                    {Array.from({ length: 7 }).map((_, index) => (
                        <div key={`sag-bos-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3 }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

// Büyük (4x15) bir sipariş kartını oluşturan bileşen
const BuyukSiparisKarti = ({ siparis }) => {
    // Kargo durumunu ve beklemede durumunu kontrol et
    const isUrgent = siparis.kargo_durumu === 'Acil';
    const isBeklemede = siparis.kargo_durumu === 'Beklemede';

    const kartStili = {
        background: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '11px',
        fontFamily: 'Poppins, sans-serif',
        border: isUrgent ? '2px solid #dc3545' : isBeklemede ? '2px solid #FFCC24' : '2px solid #333', // Acil ise kırmızı, beklemede ise sarı çerçeve
        boxSizing: 'border-box'
    };
    const baslikStili = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#f0f0f0',
        padding: '2px 6px',
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
        fontSize: '12px'
    };
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const urunIzgaraKapsayici = {
        display: 'flex',
        flex: 1,
        overflow: 'hidden'
    };
    const urunSutunu = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    };
    const urunHucre = {
        padding: '1px 4px',
        fontSize: '9px',
        borderBottom: '1px solid #eee',
        borderRight: '1px solid #eee',
        flex: '1 1 0',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };
    const urunler = siparis.urunler || [];
    const solSutunUrunleri = urunler.slice(0, 15);
    const sagSutunUrunleri = urunler.slice(15, 30);

    return (
        <div style={kartStili}>
            <div style={baslikStili}>
                <div style={{ ...kaynakKutusuTemelStili, background: kaynakRenkleri[siparis.kaynak] || '#ccc' }}>
                {siparis.kaynak}
                </div>
                <span>{siparis.numara}{siparis.alternatif_numara ? ` (${siparis.alternatif_numara})` : ''}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                    {renderSiparisIcons(siparis)}
                </div>
            </div>
            <div style={urunIzgaraKapsayici}>
                <div style={urunSutunu}>
                    {Array.from({ length: 15 }).map((_, index) => {
                        const urun = solSutunUrunleri[index];
                        return (<div key={`buyuk-sol-${index}`} style={{ display: 'flex', flex: 1 }}><span style={{ ...urunHucre, flex: 3, borderLeft: '1px solid #eee' }}>{urun ? urun.kod : '\u00A0'}</span><span style={{ ...urunHucre, flex: 1, justifyContent: 'center' }}>{urun ? urun.adet : '\u00A0'}</span></div>);
                    })}
                </div>
                <div style={{ ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                    {Array.from({ length: 15 }).map((_, index) => {
                        const urun = sagSutunUrunleri[index];
                        return (<div key={`buyuk-sag-${index}`} style={{ display: 'flex', flex: 1 }}><span style={{ ...urunHucre, flex: 3 }}>{urun ? urun.kod : '\u00A0'}</span><span style={{ ...urunHucre, flex: 1, justifyContent: 'center' }}>{urun ? urun.adet : '\u00A0'}</span></div>);
                    })}
                </div>
            </div>
        </div>
    );
};

// Boş Büyük Kart
const BosBuyukSiparisKarti = () => {
    const kartStili = {
        background: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
        opacity: 0.6
    };
    const baslikStili = {
        height: '18px',
        background: '#f0f0f0',
        borderBottom: '1px solid #ccc'
    };
    const urunIzgaraKapsayici = {
        display: 'flex',
        flex: 1,
        overflow: 'hidden'
    };
    const urunSutunu = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    };
    const urunHucre = {
        height: '16px',
        borderBottom: '1px solid #eee',
        borderRight: '1px solid #eee',
        flex: '1 1 0'
    };

    return (
        <div style={kartStili}>
            <div style={baslikStili}></div>
            <div style={urunIzgaraKapsayici}>
                <div style={urunSutunu}>
                    {Array.from({ length: 15 }).map((_, index) => (
                        <div key={`sol-bos-buyuk-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3, borderLeft: '1px solid #eee' }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
                <div style={{ ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                    {Array.from({ length: 15 }).map((_, index) => (
                        <div key={`sag-bos-buyuk-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3 }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const SadeceBaskiSatiri = ({ siparis }) => {
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const satirStili = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#f0f0f0',
        padding: '2px 6px',
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
        fontSize: '12px',
        boxSizing: 'border-box',
        width: '100%'
    };

    return (
        <div style={satirStili}>
            <div style={{ ...kaynakKutusuTemelStili, background: kaynakRenkleri[siparis.kaynak] || '#ccc' }}>
                {siparis.kaynak}
            </div>
            <span>{siparis.numara}{siparis.alternatif_numara ? ` (${siparis.alternatif_numara})` : ''}</span>
            <div style={{ width: '40px', textAlign: 'right', display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
                {renderSiparisIcons(siparis)}
            </div>
        </div>
    );
};

// Boş bir "Sadece Makine Baskısı" satırını oluşturan bileşen
const BosSadeceBaskiSatiri = () => {
    const satirStili = {
        background: '#f9f9f9',
        borderBottom: '1px solid #ccc',
        boxSizing: 'border-box',
        width: '100%'
    };
    return <div style={satirStili}></div>;
};

// satir/sutun: varsayılan 2x27 = 54 ürün. 54'ü aşan siparişlerde (yılda birkaç kez) daha büyük ızgarayla çağrılır.
const EkstraBuyukSiparisKarti = ({ siparis, satir = 27, sutun = 2 }) => {
    // Stiller, BuyukSiparisKarti ile aynı, sadece satır sayısı ve çerçeve rengi farklı.
    // Kargo durumunu ve beklemede durumunu kontrol et
    const isUrgent = siparis.kargo_durumu === 'Acil';
    const isBeklemede = siparis.kargo_durumu === 'Beklemede';
    
    const kartStili = { background: 'white', height: '100%', display: 'flex', flexDirection: 'column', fontSize: '11px', fontFamily: 'Poppins, sans-serif', border: isUrgent ? '2px solid #dc3545' : isBeklemede ? '2px solid #FFCC24' : '2px solid #000000', boxSizing: 'border-box' };
    const baslikStili = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f0f0f0', padding: '2px 6px', fontWeight: 'bold', borderBottom: '1px solid #ccc', fontSize: '12px' };
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const urunIzgaraKapsayici = { display: 'flex', flex: 1, overflow: 'hidden' };
    const urunSutunu = { flex: 1, display: 'flex', flexDirection: 'column' };
    const urunHucre = { padding: '1px 4px', fontSize: '9px', borderBottom: '1px solid #eee', borderRight: '1px solid #eee', flex: '1 1 0', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    
    const urunler = siparis.urunler || [];

    return (
        <div style={kartStili}>
            <div style={baslikStili}>
                <div style={{ ...kaynakKutusuTemelStili, background: kaynakRenkleri[siparis.kaynak] || '#ccc' }}>
                {siparis.kaynak}
                </div>
                <span>{siparis.numara}{siparis.alternatif_numara ? ` (${siparis.alternatif_numara})` : ''}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                    {renderSiparisIcons(siparis)}
                </div>
            </div>
            <div style={urunIzgaraKapsayici}>
                {Array.from({ length: sutun }).map((_, s) => (
                    <div key={`ekstra-sutun-${s}`} style={s === 0 ? urunSutunu : { ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                        {Array.from({ length: satir }).map((_, index) => {
                            const urun = urunler[s * satir + index];
                            return (<div key={`ekstra-${s}-${index}`} style={{ display: 'flex', flex: 1 }}><span style={{ ...urunHucre, flex: 3, ...(s === 0 ? { borderLeft: '1px solid #eee' } : {}) }}>{urun ? urun.kod : '\u00A0'}</span><span style={{ ...urunHucre, flex: 1, justifyContent: 'center' }}>{urun ? urun.adet : '\u00A0'}</span></div>);
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

const BosEkstraBuyukSiparisKarti = () => {
    const kartStili = { background: 'white', height: '100%', display: 'flex', flexDirection: 'column', border: '1px solid #ccc', boxSizing: 'border-box', opacity: 0.6 };
    const baslikStili = { height: '18px', background: '#f0f0f0', borderBottom: '1px solid #ccc' };
    const urunIzgaraKapsayici = { display: 'flex', flex: 1, overflow: 'hidden' };
    const urunSutunu = { flex: 1, display: 'flex', flexDirection: 'column' };
    const urunHucre = { height: '13px', borderBottom: '1px solid #eee', borderRight: '1px solid #eee', flex: '1 1 0' };

    return (
        <div style={kartStili}>
            <div style={baslikStili}></div>
            <div style={urunIzgaraKapsayici}>
                <div style={urunSutunu}>
                    {Array.from({ length: 27 }).map((_, index) => (
                        <div key={`sol-bos-ekstra-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3, borderLeft: '1px solid #eee' }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
                <div style={{ ...urunSutunu, borderLeft: '1px solid #ccc' }}>
                    {Array.from({ length: 27 }).map((_, index) => (
                        <div key={`sag-bos-ekstra-${index}`} style={{ display: 'flex', flex: 1 }}>
                            <span style={{ ...urunHucre, flex: 3 }}></span>
                            <span style={{ ...urunHucre, flex: 1 }}></span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const UrunSayilariPaneli = ({ urunler }) => {
    const panelStili = { border: '1px solid #ccc', padding: '10px' };
    const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '10px', marginBottom: '15px' };
    const thStyle = { background: '#E5E5E5', padding: '2px 5px', border: '1px solid #ccc', textAlign: 'left', fontWeight: 'bold' };
    const tdStyle = { padding: '2px 5px', border: '1px solid #ccc' };
    const tdValueStyle = { ...tdStyle, textAlign: 'center', fontWeight: 'bold', width: '25%' };

    // Şablondaki sabit satırları bir dizi olarak tanımlayalım
    const hazirBaskiSatirlari = ['METRELIK EBAT', 'BÜYÜK EBAT', 'ESMAÜL HÜSNA', 'ÖZEL BASKI'];
    const makineBaskiSatirlari = ['Orta Ebat (35x50)', 'Küçük Ebat (21x30)', 'Mini Ebat (15x21)', 'Uzun Ebat (35x70)', 'Döşeme Baskı', 'Dekopaj Baskı'];
    const yanUrunlerListesi = Object.entries(urunler?.yan_urun || {}).sort((a, b) => a[0].localeCompare(b[0]));
    
    // Yan ürünler listesini iki sütuna bölelim
    const maxItemsPerColumn = Math.ceil(yanUrunlerListesi.length / 2);
    const leftColumnItems = yanUrunlerListesi.slice(0, maxItemsPerColumn);
    const rightColumnItems = yanUrunlerListesi.slice(maxItemsPerColumn);

    return (
        <div>
            <div style={{ width: '200px' }}>
                
                {/* HAZIR BASKI TABLOSU */}
                <table style={tableStyle}>
                    <thead><tr><th colSpan="2" style={thStyle}>HAZIR BASKI SAYILARI</th></tr></thead>
                    <tbody>
                        {hazirBaskiSatirlari.map(satir => (
                            <tr key={satir}>
                                <td style={tdStyle}>{satir}</td>
                                <td style={tdValueStyle}>{urunler?.hazir_baski?.[satir] || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* MAKİNE BASKI TABLOSU */}
                <table style={tableStyle}>
                    <thead><tr><th colSpan="2" style={thStyle}>MAKİNE BASKI SAYILARI</th></tr></thead>
                    <tbody>
                        {makineBaskiSatirlari.map(satir => (
                            <tr key={satir}>
                                <td style={tdStyle}>{satir}</td>
                                <td style={tdValueStyle}>{urunler?.makine_baski?.[satir] || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* YAN ÜRÜN TABLOSU - İki sütunlu düzen */}
                <table style={{...tableStyle, marginBottom: 0}}>
                    <thead><tr><th colSpan="4" style={thStyle}>YAN ÜRÜN SAYILARI</th></tr></thead>
                    <tbody>
                        {yanUrunlerListesi.length > 0 ? (
                            <>
                                {/* İlk sütun ve ikinci sütun elemanları yan yana gösterilecek */}
                                {Array.from({ length: maxItemsPerColumn }).map((_, index) => (
                                    <tr key={`row-${index}`}>
                                        {/* Sol sütun */}
                                        {leftColumnItems[index] && (
                                            <>
                                                <td style={tdStyle}>{leftColumnItems[index][0]}</td>
                                                <td style={{...tdValueStyle, width: '12.5%'}}>{leftColumnItems[index][1]}</td>
                                            </>
                                        )}
                                        {/* Sağ sütun */}
                                        {rightColumnItems[index] ? (
                                            <>
                                                <td style={tdStyle}>{rightColumnItems[index][0]}</td>
                                                <td style={{...tdValueStyle, width: '12.5%'}}>{rightColumnItems[index][1]}</td>
                                            </>
                                        ) : (
                                            // Sağ sütunda eleman yoksa boş hücreler
                                            <>
                                                <td style={tdStyle}></td>
                                                <td style={{...tdValueStyle, width: '12.5%'}}></td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr><td colSpan="4" style={{...tdStyle, textAlign: 'center', color: '#888'}}>Veri Yok</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


// Ana Defter Dökümü Bileşeni
function DefterDokumu() {
    // --- STATE'LER (HER ZAMAN EN ÜSTTE) ---
    const [dokumData, setDokumData] = useState(null);
    const [loading, setLoading] = useState(true);
    // localStorage'dan son seçilen tarihi yükle, yoksa bugünün tarihini kullan
    const [seciliTarih, setSeciliTarih] = useState(() => {
        const savedDate = localStorage.getItem('defterDokumuTarih');
        return savedDate || new Date().toISOString().split('T')[0];
    });
    const [aktifDefter, setAktifDefter] = useState('defter1');
    const [tekliSiparisNumara, setTekliSiparisNumara] = useState('');

    // Özel Baskı indirme modalı
    const [ozelBaskiModalAcik, setOzelBaskiModalAcik] = useState(false);
    const [ozelBaskiMod, setOzelBaskiMod] = useState('gun'); // 'gun' | 'aralik'
    const [ozelBaskiBaslangic, setOzelBaskiBaslangic] = useState('');
    const [ozelBaskiBitis, setOzelBaskiBitis] = useState('');

    const fetchDefterData = () => {
        setLoading(true);
        // Tarihi localStorage'a kaydet
        if (seciliTarih) {
            localStorage.setItem('defterDokumuTarih', seciliTarih);
        }
        fetch(`/api/defter-dokumu?tarih=${seciliTarih}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json()).then(data => { setDokumData(data); setLoading(false); })
            .catch(error => { console.error("Hata:", error); setLoading(false); });
    };

    const renderGridCells = (siparisler, totalCells, satirSayisi) => {
    // Hangi kart ve boş kart bileşenini kullanacağımızı satır sayısına göre belirliyoruz
    let CardComponent = SiparisKarti;
    let BosCardComponent = BosSiparisKarti;

    if (satirSayisi === 30) { // Büyük kartlar 30 ürün kapasiteli
        CardComponent = BuyukSiparisKarti;
        BosCardComponent = BosBuyukSiparisKarti;
    } else if (satirSayisi === 54) { // Ekstra büyük kartlar 54 ürün kapasiteli
        CardComponent = EkstraBuyukSiparisKarti;
        BosCardComponent = BosEkstraBuyukSiparisKarti;
    }

    return Array.from({ length: totalCells }).map((_, index) => {
        const siparis = siparisler[index];
        return (
            <div key={index} style={{ height: '100%' }}>
                {siparis 
                    ? <CardComponent siparis={siparis} /> 
                    : <BosCardComponent />
                }
            </div>
            );
        });
    };

    const handlePrint = async () => {
        // O anki aktif defterin hangisi olduğunu sakla
        const originalDefter = aktifDefter; 
        const otherDefter = originalDefter === 'defter1' ? 'defter2' : 'defter1';
        const tarih = dokumData?.tarih || 'defter-dokumu';

        // DÜZELTME: ID'ler artık JSX'teki gibi tireli olacak şekilde doğru oluşturuluyor.
        const el1_id = `defter-${originalDefter.slice(-1)}-sayfa`; // "defter-1-sayfa" veya "defter-2-sayfa" oluşturur
        const el2_id = `defter-${otherDefter.slice(-1)}-sayfa`;

        const el1 = document.getElementById(el1_id);
        if (!el1) {
            alert(`Aktif defter (${el1_id}) sayfası DOM'da bulunamadı!`);
            return;
        }
        
        // PDF için SVG ikonların stil özelliklerini ayarlayan fonksiyon
        const prepareIconsForPdf = (element) => {
            // UrgentIcon'ların stilini PDF için ayarla
            const urgentIcons = element.querySelectorAll('img[alt="Acil"]');
            urgentIcons.forEach(icon => {
                icon.style.filter = ""; // PDF'de filter özelliği sorun çıkarabilir
                icon.style.width = "13px"; // PDF'de daha iyi görünmesi için biraz büyüt
            });
            
            // Diğer ikonların boyutlarını PDF için ayarla
            const hediyeIcons = element.querySelectorAll('img[alt="Hediye"]');
            hediyeIcons.forEach(icon => {
                icon.style.width = "13px";
            });
            
            const baskiYokIcons = element.querySelectorAll('img[alt="Baskı Yok"]');
            baskiYokIcons.forEach(icon => {
                icon.style.width = "13px";
            });
        };
        
        // İkonları PDF için hazırla
        prepareIconsForPdf(el1);

        alert("PDF oluşturuluyor... Lütfen bekleyin. (Adım 1/2)");

        try {
            // 1. İlk (görünürdeki) sayfanın görüntüsünü al - geliştirilmiş seçeneklerle
            const canvas1 = await html2canvas(el1, { 
                scale: 2, 
                useCORS: true,
                allowTaint: true,
                logging: false,
                imageTimeout: 0, // SVG'lerin yüklenmesi için daha fazla zaman tanı
                onclone: (document) => {
                    // Tüm SVG ikonların tam olarak yüklendiğinden emin ol
                    const images = document.querySelectorAll('img');
                    images.forEach(img => {
                        if (img.complete) return;
                        img.setAttribute('crossOrigin', 'anonymous');
                    });
                }
            });

            // 2. Programatik olarak diğer deftere geç
            setAktifDefter(otherDefter);

            // 3. React'in diğer defteri çizmesi için kısa bir bekleme süresi ver
            await new Promise(resolve => setTimeout(resolve, 100));

            const el2 = document.getElementById(el2_id);
            if (!el2) {
                // Hata durumunda, kullanıcıyı orijinal görünümüne geri döndür
                setAktifDefter(originalDefter);
                throw new Error(`Diğer defter (${el2_id}) render edilemedi.`);
            }
            
            // İkinci sayfa için de ikonları hazırla
            prepareIconsForPdf(el2);
            
            alert("PDF oluşturuluyor... (Adım 2/2)");

            // 4. İkinci sayfanın görüntüsünü al - geliştirilmiş seçeneklerle
            const canvas2 = await html2canvas(el2, { 
                scale: 2, 
                useCORS: true,
                allowTaint: true,
                logging: false,
                imageTimeout: 0, // SVG'lerin yüklenmesi için daha fazla zaman tanı
                onclone: (document) => {
                    // Tüm SVG ikonların tam olarak yüklendiğinden emin ol
                    const images = document.querySelectorAll('img');
                    images.forEach(img => {
                        if (img.complete) return;
                        img.setAttribute('crossOrigin', 'anonymous');
                    });
                }
            });
            
            // 5. PDF'i oluştur
            const pdf = new jsPDF({ 
                orientation: 'landscape', 
                unit: 'mm', 
                format: 'a3',
                hotfixes: ['px_scaling']
            });
            
            // Türkçe karakter desteği için font ayarı
            pdf.setFont('helvetica', 'normal');
            
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            
            // Canvas'ı PNG olarak al
            const imgData1 = canvas1.toDataURL('image/png', 1.0); // 1.0 tam kalite
            const imgData2 = canvas2.toDataURL('image/png', 1.0);
            
            // A3 boyutlarını tam olarak kullan, oranlamadan direkt olarak yerleştir
            // Defter-1'i her zaman ilk sayfaya koy
            if (originalDefter === 'defter1') {
                pdf.addImage(imgData1, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.addPage();
                pdf.addImage(imgData2, 'PNG', 0, 0, pdfWidth, pdfHeight);
            } else {
                pdf.addImage(imgData2, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.addPage();
                pdf.addImage(imgData1, 'PNG', 0, 0, pdfWidth, pdfHeight);
            }

            // 6. PDF'i indir
            pdf.save(`${tarih}_defter_dokumu.pdf`);

        } catch (err) {
            console.error("PDF oluşturma hatası:", err);
            alert("PDF oluşturulurken bir hata oluştu.");
        } finally {
            // 7. Her durumda, kullanıcının orijinal görünümüne geri dön
            setAktifDefter(originalDefter);
        }
    };

    const handleOzelBaskiListesi = async () => {
        // Eğer veriler yükleniyor durumundaysa bekle
        if (loading) {
            alert("Veriler yükleniyor, lütfen bekleyin...");
            return;
        }

        // Eğer veri yoksa veya sipariş listesi yoksa hata ver
        if (!dokumData || !dokumData.defter1 && !dokumData.defter2) {
            alert("Seçilen tarihte sipariş verisi bulunamadı.");
            return;
        }

        alert("Özel Baskı Listesi PDF'i oluşturuluyor... Lütfen bekleyin.");

        try {
            // A5 boyutlarında PDF oluştur (148 x 210 mm) - DİKEY
            const pdf = new jsPDF({ 
                orientation: 'portrait', 
                unit: 'mm', 
                format: 'a5',
                compress: true,
                putOnlyUsedFonts: true,
                hotfixes: ['px_scaling']
            });
            
            // Varsayılan font
            pdf.setFont('helvetica', 'normal');
            
            const pageWidth = pdf.internal.pageSize.getWidth(); // 148mm
            const pageHeight = pdf.internal.pageSize.getHeight(); // 210mm
            
            // Tüm siparişleri birleştir (defter1 ve defter2'den)
            const tumSiparisler = [...(dokumData.defter1 || []), ...(dokumData.defter2 || [])];
            
            // Özel baskı olan siparişleri filtrele
            const ozelBaskiSiparisleri = tumSiparisler.filter(siparis => {
                return siparis.urunler && siparis.urunler.some(urun => 
                    // Backend'de özel baskı ürün tipine göre belirleniyor
                    urun.kod && urun.kod.includes('ÖZEL') // Örneğin ÖZEL-BASKI gibi kodlar
                );
            });

            if (ozelBaskiSiparisleri.length === 0) {
                alert("Seçilen tarihte özel baskı siparişi bulunamadı.");
                return;
            }

            // PDF başlığını ayarla
            pdf.setFontSize(12);
            pdf.setFont("helvetica", "bold");
            
            // Tarihi gg/aa/yyyy formatına çevir
            const tarihParts = dokumData.tarih.split('-'); // 2024-01-15 formatından
            const formattedTarih = `${tarihParts[2]}/${tarihParts[1]}/${tarihParts[0]}`;
            
            // Tarihin gününü al (PDF'de ş karakteri sorunu olduğu için basitleştirilmiş)
            const tarihObj = new Date(dokumData.tarih);
            const gunIndex = tarihObj.getDay();
            const turkceGunler = ['Pazar', 'Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi'];
            const gunAdi = turkceGunler[gunIndex];
            
            // Başlık - sadece tarih ve gün adı
            const baslik = `${formattedTarih} ${gunAdi}`;
            pdf.text(baslik, pageWidth / 2, 15, { align: 'center' });

            // Tablo başlıkları - Türkçe karakter desteği ile
            pdf.setFontSize(10);
            pdf.setFont("helvetica", "bold");
            
            let yPos = 24;
            const satirYuksekligi = 6;
            const kolonlar = [
                { baslik: "", x: 5, genislik: 15 },
                { baslik: "Telefon", x: 20, genislik: 35 },
                { baslik: "Kaynak", x: 55, genislik: 20 },
                { baslik: "Durum", x: 75, genislik: 30 },
                { baslik: "Adet", x: 105, genislik: 38 },
            ];

            // Başlık satırını çiz - ortalı olarak
            kolonlar.forEach(kolon => {
                pdf.rect(kolon.x, yPos - 4, kolon.genislik, satirYuksekligi);
                
                // Başlık metnini sütun içinde ortala
                const textWidth = pdf.getStringUnitWidth(kolon.baslik) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                const ortaX = kolon.x + (kolon.genislik / 2) - (textWidth / 2);
                
                pdf.text(kolon.baslik, ortaX, yPos);
            });

            yPos += satirYuksekligi;
            pdf.setFont("helvetica", "normal");

            let siraNo = 1;
            let toplamOzelBaskiAdet = 0; // Toplam özel baskı adedi için sayaç

            ozelBaskiSiparisleri.forEach(siparis => {
                siparis.urunler.forEach(urun => {
                    // Sadece özel baskı ürünlerini işle
                    if (urun.kod && urun.kod.includes('ÖZEL')) {
                        // Sayfa kontrolü
                        if (yPos > pageHeight - 20) {
                            pdf.addPage();
                            yPos = 20;
                        }

                        // Telefon numarasından son 4 hanesi (numara alanından al)
                        const telKodu = siparis.alternatif_numara
                            ? `${siparis.numara} (${siparis.alternatif_numara})`
                            : siparis.numara || '';
                        
                        // Kaynak direkt olarak al (W, S, R)
                        const kaynak = siparis.kaynak || '';

                        // Makine baskısı kontrolü - özel baskı siparişlerinde genelde yok
                        const makineBaskisi = siparis.makine_baskisi_yok ? 'X' : '';

                        // Özel baskı adedini hesapla ve toplama ekle
                        const baskiAdet = parseInt(urun.adet || '1');
                        toplamOzelBaskiAdet += baskiAdet;
                        
                        const veriler = [
                            siraNo.toString(),
                            telKodu,
                            kaynak,
                            makineBaskisi,
                            baskiAdet.toString() // Özel baskı adedi
                        ];

                        // Satır verilerini yaz - ortalı olarak
                        kolonlar.forEach((kolon, index) => {
                            pdf.rect(kolon.x, yPos - 4, kolon.genislik, satirYuksekligi);
                            
                            let metin = veriler[index] || '';
                            
                            // Metni sütun içinde ortala
                            const textWidth = pdf.getStringUnitWidth(metin) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                            const ortaX = kolon.x + (kolon.genislik / 2) - (textWidth / 2);
                            
                            pdf.text(metin, ortaX, yPos);
                        });

                        yPos += satirYuksekligi;
                        siraNo++;
                    }
                });
            });

            // Toplam bilgisi - Türkçe karakter desteği ile
            yPos += 5; // Daha yakın mesafe
            
            // Font boyutunu büyüt ve kalın yap
            const normalFontSize = pdf.internal.getFontSize();
            pdf.setFontSize(normalFontSize * 1.2); // Font boyutunu 1.4 kat artır
            pdf.setFont("helvetica", "bold");
            
            // Sadece toplam özel baskı adedini göster - sağa dayalı
            const toplamMetni = `Toplam: ${toplamOzelBaskiAdet}`;
            // pageWidth değişkeni yukarıda zaten tanımlanmış
            pdf.text(toplamMetni, pdf.internal.pageSize.getWidth() - 10, yPos, { align: 'right' }); // Sağa dayalı
            
            // Font boyutunu eski haline getir
            pdf.setFontSize(normalFontSize);

            // PDF'i indir
            const tarih = dokumData?.tarih || new Date().toISOString().split('T')[0];
            pdf.save(`${tarih}_ozel_baski_listesi.pdf`);

        } catch (err) {
            console.error("Özel Baskı Listesi PDF oluşturma hatası:", err);
            alert("PDF oluşturulurken bir hata oluştu.");
        }
    };

    const handleOzelBaskiAralikIndir = async () => {
        if (!ozelBaskiBaslangic || !ozelBaskiBitis) {
            alert("Lütfen başlangıç ve bitiş tarihlerini seçin.");
            return;
        }
        if (ozelBaskiBaslangic > ozelBaskiBitis) {
            alert("Başlangıç tarihi bitiş tarihinden büyük olamaz.");
            return;
        }
        setOzelBaskiModalAcik(false);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`/api/ozel-baski-aralik?baslangic=${ozelBaskiBaslangic}&bitis=${ozelBaskiBitis}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (!Array.isArray(data) || data.length === 0) {
                alert("Seçilen tarih aralığında özel baskı siparişi bulunamadı.");
                return;
            }

            const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a5', compress: true, putOnlyUsedFonts: true, hotfixes: ['px_scaling'] });
            pdf.setFont('helvetica', 'normal');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            // Başlık
            pdf.setFontSize(12);
            pdf.setFont('helvetica', 'bold');
            const [by, bm, bd] = ozelBaskiBaslangic.split('-');
            const [ey, em, ed] = ozelBaskiBitis.split('-');
            pdf.text(`${bd}/${bm}/${by} - ${ed}/${em}/${ey} Ozel Baski Listesi`, pageWidth / 2, 15, { align: 'center' });

            pdf.setFontSize(10);
            let yPos = 24;
            const satirYuksekligi = 6;
            // Tarih sütunu sıra no ile telefon arasında
            const kolonlar = [
                { baslik: "",       x: 5,   genislik: 12 },
                { baslik: "Tarih",  x: 17,  genislik: 22 },
                { baslik: "Telefon",x: 39,  genislik: 30 },
                { baslik: "Kaynak", x: 69,  genislik: 18 },
                { baslik: "Durum",  x: 87,  genislik: 25 },
                { baslik: "Adet",   x: 112, genislik: 31 },
            ];

            // Başlık satırı
            kolonlar.forEach(kolon => {
                pdf.rect(kolon.x, yPos - 4, kolon.genislik, satirYuksekligi);
                const tw = pdf.getStringUnitWidth(kolon.baslik) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                pdf.text(kolon.baslik, kolon.x + (kolon.genislik / 2) - (tw / 2), yPos);
            });
            yPos += satirYuksekligi;
            pdf.setFont('helvetica', 'normal');

            let siraNo = 1;
            let toplamOzelBaskiAdet = 0;

            data.forEach(siparis => {
                (siparis.urunler || []).forEach(urun => {
                    if (yPos > pageHeight - 20) { pdf.addPage(); yPos = 20; }
                    const telKodu = siparis.alternatif_numara
                        ? `${siparis.numara} (${siparis.alternatif_numara})`
                        : siparis.numara || '';
                    const baskiAdet = parseInt(urun.adet || '1');
                    toplamOzelBaskiAdet += baskiAdet;
                    const veriler = [
                        siraNo.toString(),
                        siparis.tarih || '',
                        telKodu,
                        siparis.kaynak || '',
                        siparis.makine_baskisi_yok ? 'X' : '',
                        baskiAdet.toString()
                    ];
                    kolonlar.forEach((kolon, idx) => {
                        pdf.rect(kolon.x, yPos - 4, kolon.genislik, satirYuksekligi);
                        const metin = veriler[idx] || '';
                        const tw = pdf.getStringUnitWidth(metin) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                        pdf.text(metin, kolon.x + (kolon.genislik / 2) - (tw / 2), yPos);
                    });
                    yPos += satirYuksekligi;
                    siraNo++;
                });
            });

            yPos += 5;
            const normalFontSize = pdf.internal.getFontSize();
            pdf.setFontSize(normalFontSize * 1.2);
            pdf.setFont('helvetica', 'bold');
            pdf.text(`Toplam: ${toplamOzelBaskiAdet}`, pageWidth - 10, yPos, { align: 'right' });
            pdf.setFontSize(normalFontSize);

            pdf.save(`${ozelBaskiBaslangic}_${ozelBaskiBitis}_ozel_baski_listesi.pdf`);
        } catch (err) {
            console.error("Özel Baskı Aralık PDF hatası:", err);
            alert("PDF oluşturulurken bir hata oluştu.");
        }
    };

    const handleTekliDokum = async () => {
        if (!tekliSiparisNumara) {
            alert("Lütfen bir sipariş seçin.");
            return;
        }

        // Ek sipariş seçimi kontrolü: "8652_ek1" formatı
        const isEkSecim = tekliSiparisNumara.includes('_ek');
        let anaNumara, ekSira;
        if (isEkSecim) {
            [anaNumara, ekSira] = tekliSiparisNumara.split('_ek');
            ekSira = parseInt(ekSira);
        } else {
            anaNumara = tekliSiparisNumara;
        }

        const tumSiparislerListesi = [...(dokumData?.defter1 || []), ...(dokumData?.defter2 || [])];
        const siparis = tumSiparislerListesi.find(s => s.numara === anaNumara);
        if (!siparis) {
            alert("Seçili sipariş bulunamadı.");
            return;
        }

        // Ek sipariş seçildiyse sadece o ek siparişteki ürünleri göster
        if (isEkSecim) {
            const ekEntry = (siparis.ek_siparis_listesi || []).find(e => e.sira === ekSira);
            if (!ekEntry) {
                alert(`Ek-${ekSira} siparişi bulunamadı.`);
                return;
            }
        }
        const el = document.getElementById('tekli-dokum-render');
        if (!el) {
            alert("Render alanı bulunamadı.");
            return;
        }
        try {
            const canvas = await html2canvas(el, {
                scale: 3,
                useCORS: true,
                allowTaint: true,
                logging: false,
                backgroundColor: '#ffffff'
            });
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a5'
            });
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgData = canvas.toDataURL('image/png', 1.0);
            const margin = 8;
            pdf.addImage(imgData, 'PNG', margin, margin, pdfWidth - margin * 2, pdfHeight - margin * 2);
            const tarih = dokumData?.tarih || new Date().toISOString().split('T')[0];
            pdf.save(`${tarih}_siparis_${tekliSiparisNumara}.pdf`);
        } catch (err) {
            console.error("Sipariş döküm hatası:", err);
            alert("PDF oluşturulurken bir hata oluştu.");
        }
    };

        useEffect(() => {
        fetchDefterData();
    }, [seciliTarih]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                fetchDefterData();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [seciliTarih]);

    
    if (loading) return <div>Yükleniyor...</div>;
    if (!dokumData) return <div>Veri bulunamadı veya bir hata oluştu.</div>;

const formatliTarih = new Date(dokumData.tarih + 'T00:00:00').toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    // Siparişleri yerleşim gruplarına ayıralım
const tumSiparisler = [...(dokumData.defter1 || []), ...(dokumData.defter2 || [])];
const ekstraBuyukSiparisler = tumSiparisler.filter(s => !s.sadece_makine_baskisi && s.urun_sayisi > 30);
// 54'ü aşan bir sipariş varsa ortak alanın iki yuvası birleştirilip yalnızca o siparişe verilir (2x54 = 108 satır).
const cokBuyukSiparis = ekstraBuyukSiparisler.find(s => s.urun_sayisi > 54);
const paylasimli_ekstra_buyuk = cokBuyukSiparis ? [cokBuyukSiparis] : ekstraBuyukSiparisler.slice(0, 2); // Ortak alana en fazla 2 tane alıyoruz.
// Ortak alana giremeyen 30+ kalemli siparişler kartlara tam sığmaz → kullanıcı uyarılır
const sigmayanEkstraBuyuk = ekstraBuyukSiparisler.filter(s => !paylasimli_ekstra_buyuk.includes(s));

// 2. Ortak havuza alınan siparişlerin numaralarını bir sete kaydedelim ki tekrar listelenmesinler.
const paylasimliIdleri = new Set(paylasimli_ekstra_buyuk.map(s => s.numara));

// 3. Ortak havuza alınmayan siparişleri kendi defterlerine geri dağıtalım.
const kalan_defter1 = (dokumData.defter1 || []).filter(s => !paylasimliIdleri.has(s.numara));
const kalan_defter2 = (dokumData.defter2 || []).filter(s => !paylasimliIdleri.has(s.numara));

// 4. Şimdi kalan siparişleri kendi içlerinde sınıflandıralım.
const defter1_sadece_baski = kalan_defter1.filter(s => s.sadece_makine_baskisi);
const defter1_standart = kalan_defter1.filter(s => !s.sadece_makine_baskisi && s.urun_sayisi <= 14);
const defter1_buyuk = kalan_defter1.filter(s => !s.sadece_makine_baskisi && s.urun_sayisi > 14); // Defter-1'in büyükleri artık 30'a kadar olabilir.

// 42 standart slota sığmayan siparişler → ekstra büyük alanda boş slot varsa oraya yerleştir
const defter1_standart_tasma = defter1_standart.length > 42 ? defter1_standart.slice(42) : [];
const bosEkstraBuyukSlot = Math.max(0, 3 - defter1_buyuk.length);
const defter1_buyuk_gosterilecek = [...defter1_buyuk, ...defter1_standart_tasma.slice(0, bosEkstraBuyukSlot)];

// Ekstra büyük alan da doluysa hâlâ sığmayan siparişler → sayfa-2'nin başına taşı
const defter1_tasma_artik = defter1_standart_tasma.slice(bosEkstraBuyukSlot);

const defter2_standart = kalan_defter2.filter(s => s.urun_sayisi <= 14);
const defter2_buyuk = kalan_defter2.filter(s => s.urun_sayisi > 14 && s.urun_sayisi <= 30);
// defter2_ekstra_buyuk artık kullanılmıyor, onun yerine "paylasimli_ekstra_buyuk" var.

// Sayfa-1'den taşanlar sayfa-2'nin başına eklenir, sayfa-2'nin kendi siparişleri arkadan devam eder
const defter2_standart_gosterilecek = [...defter1_tasma_artik, ...defter2_standart];

const PaylasimliAlan = ({ siparisler }) => {
    if (siparisler.length === 1 && siparisler[0].urun_sayisi > 54) {
        return (
            <div style={{ height: '100%' }}>
                <EkstraBuyukSiparisKarti siparis={siparisler[0]} satir={Math.max(54, Math.ceil(siparisler[0].urun_sayisi / 2))} />
            </div>
        );
    }
    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px', height: '100%' }}>
            {renderGridCells(siparisler, 2, 54, '#8e44ad')}
        </div>
    );
};

const OzetPaneli = ({ ozet }) => {
    const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '11px' };
    const thStyle = { background: '#E5E5E5', padding: '0px 0px 0px 4px', border: '1px solid #ccc', textAlign: 'left', fontWeight: 'bold' };
    const tdStyle = { padding: '0px 0px 0px 4px', border: '1px solid #ccc' };
    const tdValueStyle = { ...tdStyle, textAlign: 'center', padding: '0px', fontWeight: 'bold' };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <table style={{ ...tableStyle, height: '100%' }}>
                <tbody>
                    <tr>
                        <td style={{...thStyle, width: '70%'}}>TOPLAM PAKET</td>
                        <td style={tdValueStyle}>{ozet.toplam_paket || 0}</td>
                    </tr>
                    <tr>
                        <th colSpan="2" style={thStyle}>SİPARİŞ KAYNAĞI</th>
                    </tr>
                    <tr>
                        <td style={tdStyle}>WHATSAPP</td>
                        <td style={tdValueStyle}>{ozet.kaynaklar?.W || 0}</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>WEB</td>
                        <td style={tdValueStyle}>{ozet.kaynaklar?.S || 0}</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>RESMİ EVRAK</td>
                        <td style={tdValueStyle}>{ozet.kaynaklar?.R || 0}</td>
                    </tr>
                    <tr>
                        <th colSpan="2" style={thStyle}>MAKİNE BASKISI</th>
                    </tr>
                    <tr>
                        <td style={tdStyle}>VAR</td>
                        <td style={tdValueStyle}>{ozet.makine_baskisi_durumu?.VAR || 0}</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>YOK</td>
                        <td style={tdValueStyle}>{ozet.makine_baskisi_durumu?.YOK || 0}</td>
                    </tr>
                    <tr>
                        <th colSpan="2" style={thStyle}>ÖZEL BASKI</th>
                    </tr>
                    <tr>
                        <td style={tdStyle}>VAR</td>
                        <td style={tdValueStyle}>{ozet.ozel_baski_durumu?.VAR || 0}</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>YOK</td>
                        <td style={tdValueStyle}>{ozet.ozel_baski_durumu?.YOK || 0}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', fontFamily: 'Poppins, sans-serif', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input type="date" value={seciliTarih} onChange={(e) => setSeciliTarih(e.target.value)} style={{ padding: '4px 12px', fontFamily: 'Poppins, sans-serif' }} />
                    <div style={{ width: '10px' }}></div>
                    <button onClick={() => setAktifDefter('defter1')} style={{ padding: '6px 12px', cursor: 'pointer', background: aktifDefter === 'defter1' ? '#3884C2' : 'white', color: aktifDefter === 'defter1' ? 'white' : 'black', border: '1px solid #ccc', borderRadius: '5px', fontFamily: 'Poppins, sans-serif' }}>Defter-1</button>
                    <div style={{ width: '3px' }}></div>
                    <button onClick={() => setAktifDefter('defter2')} style={{ padding: '6px 12px', cursor: 'pointer', background: aktifDefter === 'defter2' ? '#3884C2' : 'white', color: aktifDefter === 'defter2' ? 'white' : 'black', border: '1px solid #ccc', borderRadius: '5px', fontFamily: 'Poppins, sans-serif' }}>Defter-2</button>
                    {defter1_tasma_artik.length > 0 && (
                        <div style={{ marginLeft: '12px', padding: '5px 12px', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '5px', color: '#856404', fontSize: '12px', fontFamily: 'Poppins, sans-serif', fontWeight: '500' }}>
                            ⚠️ {defter1_tasma_artik.length} Defter-1 siparişi alan yetersizliğinden Defter-2 sayfasına yazıldı
                        </div>
                    )}
                    {sigmayanEkstraBuyuk.length > 0 && (
                        <div style={{ marginLeft: '12px', padding: '5px 12px', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '5px', color: '#856404', fontSize: '12px', fontFamily: 'Poppins, sans-serif', fontWeight: '500' }}>
                            ⚠️ {sigmayanEkstraBuyuk.map(s => s.numara).join(', ')} defterde tam gösterilemiyor, Sipariş Dökümü ile ayrıca yazdırın
                        </div>
                    )}
                </div>
                <div style={{ flex: 1, minWidth: '20px' }}></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <select
                        value={tekliSiparisNumara}
                        onChange={e => setTekliSiparisNumara(e.target.value)}
                        style={{ padding: '4px 8px', fontFamily: 'Poppins, sans-serif', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', maxWidth: '200px' }}
                    >
                        <option value="">-- Sipariş Seç --</option>
                        {tumSiparisler
                            .filter(s => !s.sadece_makine_baskisi)
                            .sort((a, b) => String(a.numara).localeCompare(String(b.numara), undefined, { numeric: true }))
                            .flatMap(s => {
                                const son4 = s.numara ? String(s.numara).slice(-4) : '????';
                                const altSon4 = s.alternatif_numara ? ` (${String(s.alternatif_numara).slice(-4)})` : '';
                                const anaEntry = (
                                    <option key={s.numara} value={s.numara}>
                                        {son4}{altSon4}
                                    </option>
                                );
                                const ekEntries = (s.ek_siparis_listesi || []).map(ek => (
                                    <option key={`${s.numara}_ek${ek.sira}`} value={`${s.numara}_ek${ek.sira}`}>
                                        {son4}{altSon4} Ek-{ek.sira}
                                    </option>
                                ));
                                return [anaEntry, ...ekEntries];
                            })}
                    </select>
                    <button
                        onClick={handleTekliDokum}
                        disabled={!tekliSiparisNumara}
                        style={{
                            padding: '5px 12px',
                            background: tekliSiparisNumara ? '#fff' : '#f0f0f0',
                            fontFamily: 'Poppins, sans-serif',
                            alignItems: 'center',
                            display: 'flex',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            gap: '8px',
                            cursor: tekliSiparisNumara ? 'pointer' : 'not-allowed',
                            opacity: tekliSiparisNumara ? 1 : 0.5,
                            marginRight: '16px'
                        }}
                    >
                        <img src={DownloadIcon} alt="Sipariş Dökümü" style={{ height: '14px' }} />
                        <span>Sipariş Dökümü</span>
                    </button>
                    <button 
                        onClick={() => {
                            setOzelBaskiMod('gun');
                            setOzelBaskiBaslangic(seciliTarih);
                            setOzelBaskiBitis(seciliTarih);
                            setOzelBaskiModalAcik(true);
                        }}
                        style={{ 
                            padding: '5px 12px', 
                            background: 'f8f8f8', 
                            fontFamily: 'poppins', 
                            alignItems: 'center', 
                            display: 'flex', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px', 
                            gap: '8px',
                        }}>
                        <img src={DownloadIcon} alt="Özel Baskılar" style={{ height: '14px' }} />
                        <span>Özel Baskılar</span>
                    </button>
                    <button 
                        onClick={handlePrint} 
                        style={{ 
                            padding: '5px 12px', 
                            background: 'f8f8f8', 
                            fontFamily: 'poppins', 
                            alignItems: 'center', 
                            display: 'flex', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px', 
                            gap: '8px',
                        }}>
                        <img src={DownloadIcon} alt="Defter Dökümü" style={{ height: '14px' }} />
                        <span>Defter Dökümü</span>
                    </button>
                </div>
                <div style={{ width: '3px' }}></div>
            </div>

            <div style={{ flex: 1, overflow: 'auto', border: '1px solid #ccc' }}>
            {aktifDefter === 'defter1' && (
                <div id="defter-1-sayfa" style={{ width: '1575px', height: '1117px', background: '#ffffff', padding: '15px', boxSizing: 'border-box', border: '1px solid #ccc'}}>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'stretch', height: '100%' }}>
                        <div style={{ flex: 7, display: 'flex', alignItems: 'stretch', gap: '6px', height: '100%' }}>
                            <div style={{ flex: 6, display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gridTemplateRows: 'repeat(7, 1fr)', gridAutoFlow: 'column', height: '100%' }}>
                                {renderGridCells(defter1_standart, 42, 14, '#333')}
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px', height: '100%' }}>
                                {renderGridCells(defter1_buyuk_gosterilecek, 3, 30, '#c0392b')}
                            </div>
                        </div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px', height: '100%' }}>
                            <div style={{ flex: 1.5, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <h4 style={{ 
                                    marginTop: 0, 
                                    marginBottom: '6px', 
                                    textAlign: 'center', 
                                    background: '#E5E5E5', 
                                    padding: '4px', 
                                    borderRadius: '4px', 
                                    fontWeight: '600', 
                                    fontSize: '12px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    {new Date(dokumData.tarih.split('.').reverse().join('-')).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', weekday: 'long' })}
                                </h4>
                                <div style={{ 
                                    border: '1px solid #ccc', 
                                    flex: 1, 
                                    display: 'grid',
                                    gridTemplateRows: 'repeat(35, 1fr)',
                                    overflow: 'hidden',
                                    marginTop: '4px'
                                }}>
                                    {defter1_sadece_baski.length > 0 ? (
                                        <>
                                            {defter1_sadece_baski.map((siparis, index) => (
                                                <SadeceBaskiSatiri key={`sadece-baski-${index}`} siparis={siparis} />
                                            ))}
                                            {/* Kalan boş satırları ekle, toplam 35 satır olacak şekilde */}
                                            {Array.from({ length: Math.max(0, 35 - defter1_sadece_baski.length) }).map((_, index) => (
                                                <BosSadeceBaskiSatiri key={`sadece-baski-bos-${index}`} />
                                            ))}
                                        </>
                                    ) : (
                                        // Hiç sipariş yoksa tam 35 tane boş satır göster
                                        Array.from({ length: 35 }).map((_, index) => (
                                            <BosSadeceBaskiSatiri key={`sadece-baski-bos-${index}`} />
                                        ))
                                    )}
                                </div>
                            </div>
                            <div style={{ flex: 0.5, display: 'flex', flexDirection: 'column' }}>
                                <OzetPaneli ozet={dokumData.ozet} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {aktifDefter === 'defter2' && (
                <div id="defter-2-sayfa" style={{ width: '1575px', height: '1117px', background: '#ffffff', padding: '15px', boxSizing: 'border-box', border: '1px solid #ccc' }}>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'stretch', height: '100%' }}>
                        <div style={{ flex: 8, display: 'flex', alignItems: 'stretch', gap: '6px', height: '100%' }}>
                            <div style={{ flex: 5, display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridTemplateRows: 'repeat(7, 1fr)', gridAutoFlow: 'column', height: '100%' }}>
                                {renderGridCells(defter2_standart_gosterilecek, 35, 14, '#333')}
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px', height: '100%' }}>
                                {renderGridCells(defter2_buyuk, 3, 30, '#c0392b')}
                            </div>
                            <div style={{ flex: 1, height: '100%' }}>
                                <PaylasimliAlan siparisler={paylasimli_ekstra_buyuk} />
                            </div>
                        </div>
                        <div style={{ width: '200px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                            {/* Tarih başlığı eklendi */}
                            <div style={{ 
                                marginBottom: '14px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <h4 style={{ 
                                    margin: 0, 
                                    textAlign: 'center', 
                                    background: '#E5E5E5', 
                                    padding: '4px', 
                                    borderRadius: '4px', 
                                    fontWeight: '600', 
                                    fontSize: '12px',
                                    width: '100%',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    {new Date(dokumData.tarih.split('.').reverse().join('-')).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', weekday: 'long' })}
                                </h4>
                            </div>
                            {/* Bilgi paneli biraz aşağıda */}
                            <div style={{ flex: 1 }}>
                                <UrunSayilariPaneli urunler={dokumData.ozet.urun_sayilari} />
                            </div>
                        </div>
                    </div>
                </div>
                
            )}
            </div>

            {/* Tekli Döküm için gizli render alanı */}
            {tekliSiparisNumara && (() => {
                const isEkSecim = tekliSiparisNumara.includes('_ek');
                const anaNumara = isEkSecim ? tekliSiparisNumara.split('_ek')[0] : tekliSiparisNumara;
                const ekSira = isEkSecim ? parseInt(tekliSiparisNumara.split('_ek')[1]) : null;
                const siparis = tumSiparisler.find(s => s.numara === anaNumara);
                if (!siparis) return null;

                // Ek seçimde sadece ek siparişin ürünlerini göster
                let renderSiparis = siparis;
                if (isEkSecim && ekSira) {
                    const ekEntry = (siparis.ek_siparis_listesi || []).find(e => e.sira === ekSira);
                    if (ekEntry) {
                        renderSiparis = { ...siparis, urunler: ekEntry.urunler, urun_sayisi: ekEntry.urunler.length };
                    }
                }

                let CardComp = SiparisKarti;
                let kartProps = {};
                if (renderSiparis.urun_sayisi > 54) {
                    // A5 yatay sayfaya sığması için 54'ü aşan siparişler 4 sütuna yayılır
                    CardComp = EkstraBuyukSiparisKarti;
                    kartProps = { sutun: 4, satir: Math.max(27, Math.ceil(renderSiparis.urun_sayisi / 4)) };
                }
                else if (renderSiparis.urun_sayisi > 30) CardComp = EkstraBuyukSiparisKarti;
                else if (renderSiparis.urun_sayisi > 14) CardComp = BuyukSiparisKarti;
                return (
                    <div
                        id="tekli-dokum-render"
                        style={{
                            position: 'fixed',
                            top: '-9999px',
                            left: '-9999px',
                            // 4 sütunlu kartta ürün kodları kesilmesin diye alan (oran korunarak) iki katına çıkar
                            width: kartProps.sutun ? '800px' : '400px',
                            height: kartProps.sutun ? '564px' : '282px',
                            background: '#ffffff'
                        }}
                    >
                        <CardComp siparis={renderSiparis} {...kartProps} />
                    </div>
                );
            })()}

            {/* Özel Baskı İndirme Modalı */}
            {ozelBaskiModalAcik && (
                <div
                    style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 3000 }}
                    onClick={() => setOzelBaskiModalAcik(false)}
                >
                    <div
                        style={{ background: 'white', borderRadius: '10px', padding: '28px 28px 22px', width: '340px', boxShadow: '0 4px 24px rgba(0,0,0,0.18)', fontFamily: 'Poppins, sans-serif' }}
                        onClick={e => e.stopPropagation()}
                    >
                        <h3 style={{ margin: '0 0 18px 0', fontWeight: 600, fontSize: '15px' }}>Özel Baskılar İndir</h3>

                        {/* Mod seçimi */}
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '18px' }}>
                            <button
                                onClick={() => setOzelBaskiMod('gun')}
                                style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #ccc', background: ozelBaskiMod === 'gun' ? '#3884c2' : '#f8f8f8', color: ozelBaskiMod === 'gun' ? 'white' : '#333', cursor: 'pointer', fontFamily: 'Poppins', fontWeight: 600, fontSize: '13px' }}
                            >
                                Seçili Gün
                            </button>
                            <button
                                onClick={() => setOzelBaskiMod('aralik')}
                                style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #ccc', background: ozelBaskiMod === 'aralik' ? '#3884c2' : '#f8f8f8', color: ozelBaskiMod === 'aralik' ? 'white' : '#333', cursor: 'pointer', fontFamily: 'Poppins', fontWeight: 600, fontSize: '13px' }}
                            >
                                Tarih Aralığı
                            </button>
                        </div>

                        {ozelBaskiMod === 'gun' && (
                            <p style={{ margin: '0 0 18px 0', fontSize: '13px', color: '#555' }}>
                                Seçili gün ({seciliTarih}) için özel baskı listesi indirilecek.
                            </p>
                        )}

                        {ozelBaskiMod === 'aralik' && (
                            <div style={{ marginBottom: '18px' }}>
                                <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Başlangıç</label>
                                <input
                                    type="date"
                                    value={ozelBaskiBaslangic}
                                    onChange={e => setOzelBaskiBaslangic(e.target.value)}
                                    style={{ width: '100%', padding: '7px 10px', border: '1px solid #ccc', borderRadius: '6px', fontFamily: 'Poppins', fontSize: '13px', boxSizing: 'border-box', marginBottom: '10px' }}
                                />
                                <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Bitiş</label>
                                <input
                                    type="date"
                                    value={ozelBaskiBitis}
                                    onChange={e => setOzelBaskiBitis(e.target.value)}
                                    style={{ width: '100%', padding: '7px 10px', border: '1px solid #ccc', borderRadius: '6px', fontFamily: 'Poppins', fontSize: '13px', boxSizing: 'border-box' }}
                                />
                            </div>
                        )}

                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <button onClick={() => setOzelBaskiModalAcik(false)} style={{ padding: '7px 18px', background: '#f8f8f8', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontFamily: 'Poppins' }}>Vazgeç</button>
                            <button
                                onClick={() => {
                                    if (ozelBaskiMod === 'gun') {
                                        setOzelBaskiModalAcik(false);
                                        handleOzelBaskiListesi();
                                    } else {
                                        handleOzelBaskiAralikIndir();
                                    }
                                }}
                                style={{ padding: '7px 18px', background: '#3884c2', color: 'white', border: '1px solid #3884c2', borderRadius: '6px', cursor: 'pointer', fontFamily: 'Poppins', fontWeight: 600 }}
                            >
                                İndir
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DefterDokumu;
